function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import makeStyles from "@material-ui/core/styles/makeStyles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Alert from "@material-ui/lab/Alert";
import ns from "mirador/dist/es/src/config/css-ns";
import ScrollIndicatedDialogContent from "mirador/dist/es/src/containers/ScrollIndicatedDialogContent";
import PropTypes from "prop-types";
import React, { useState } from "react";
import CopyToClipboard from "./dialog/CopyToClipboard";
import RightsInformation from "./dialog/RightsInformation";
import ShareButton from "./dialog/ShareButton";
var useStyles = makeStyles(function (theme) {
  return {
    actions: {
      justifyContent: "space-between",
      flexWrap: "wrap"
    },
    actionButtons: {
      flexWrap: "wrap"
    },
    alert: {
      marginBottom: theme.spacing(1)
    }
  };
});
var supportsClipboard = ("clipboard" in navigator);
var ShareCanvasLinkDialog = function ShareCanvasLinkDialog(_ref) {
  var canvases = _ref.canvases,
    config = _ref.config,
    containerId = _ref.containerId,
    manifestId = _ref.manifestId,
    visibleCanvases = _ref.visibleCanvases,
    label = _ref.label,
    rights = _ref.rights,
    t = _ref.t,
    updateConfig = _ref.updateConfig,
    windowViewType = _ref.windowViewType;
  var dialogOpen = config.dialogOpen,
    enabled = config.enabled,
    showRightsInformation = config.showRightsInformation,
    getCanvasLink = config.getCanvasLink;
  var _useState = useState(false),
    copiedToClipboard = _useState[0],
    setCopiedToClipboard = _useState[1];
  var _useStyles = useStyles(),
    actions = _useStyles.actions,
    actionButtons = _useStyles.actionButtons,
    alert = _useStyles.alert;
  if (!enabled || !dialogOpen || visibleCanvases.length === 0) {
    return null;
  }
  var closeDialog = function closeDialog() {
    return updateConfig(_extends({}, config, {
      dialogOpen: false
    }));
  };
  var canvasLink = getCanvasLink({
    canvases: canvases,
    manifestId: manifestId,
    visibleCanvases: visibleCanvases,
    windowViewType: windowViewType
  });
  var getPreviewUrl = function getPreviewUrl(width) {
    var _visibleCanvases$;
    return ((_visibleCanvases$ = visibleCanvases[0]) === null || _visibleCanvases$ === void 0 ? void 0 : _visibleCanvases$.imageServiceIds[0]) + "/full/" + width + ",/0/default.jpg";
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    container: document.querySelector("#" + containerId + " ." + ns("viewer")),
    fullWidth: true,
    maxWidth: "sm",
    scroll: "paper",
    open: dialogOpen,
    onClose: closeDialog
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    disableTypography: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, /*#__PURE__*/React.createElement(Box, {
    fontWeight: "fontWeightBold"
  }, t("canvasLink.shareLink")))), /*#__PURE__*/React.createElement(ScrollIndicatedDialogContent, {
    dividers: true
  }, copiedToClipboard && /*#__PURE__*/React.createElement(Alert, {
    className: alert,
    closeText: t("canvasLink.close"),
    onClose: function onClose() {
      return setCopiedToClipboard(false);
    },
    severity: "success"
  }, t("canvasLink.copiedToClipboard")), /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(CopyToClipboard, {
        onCopy: function onCopy() {
          navigator.clipboard.writeText(canvasLink);
          setCopiedToClipboard(true);
          setTimeout(function () {
            return setCopiedToClipboard(false);
          }, 3000);
        },
        supported: supportsClipboard,
        t: t
      }),
      readOnly: true
    },
    size: "small",
    value: canvasLink,
    variant: "outlined"
  }), showRightsInformation && /*#__PURE__*/React.createElement(RightsInformation, {
    t: t,
    rights: rights
  })), /*#__PURE__*/React.createElement(DialogActions, {
    className: actions
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    className: actionButtons
  }, ["envelope", "facebook", "pinterest", "x", "whatsapp"].map(function (p) {
    return /*#__PURE__*/React.createElement(ShareButton, {
      canvasLink: canvasLink,
      key: p,
      label: label,
      provider: p,
      thumbnailUrl: getPreviewUrl(250),
      title: t("canvasLink.share." + p)
    });
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "1 0 0"
    }
  }), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: closeDialog
  }, t("canvasLink.close"))));
};
ShareCanvasLinkDialog.defaultProps = {
  canvases: [],
  label: "",
  rights: [],
  visibleCanvases: []
};
ShareCanvasLinkDialog.propTypes = process.env.NODE_ENV !== "production" ? {
  canvases: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired
  })),
  config: PropTypes.shape({
    dialogOpen: PropTypes.bool.isRequired,
    enabled: PropTypes.bool.isRequired,
    showRightsInformation: PropTypes.bool.isRequired,
    getCanvasLink: PropTypes.func.isRequired
  }).isRequired,
  containerId: PropTypes.string.isRequired,
  label: PropTypes.string,
  manifestId: PropTypes.string.isRequired,
  rights: PropTypes.arrayOf(PropTypes.string),
  t: PropTypes.func.isRequired,
  updateConfig: PropTypes.func.isRequired,
  visibleCanvases: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    imageServiceIds: PropTypes.arrayOf(PropTypes.string).isRequired
  })),
  windowViewType: PropTypes.string.isRequired
} : {};
export default ShareCanvasLinkDialog;